"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defaultHTMLElementModels = _interopRequireDefault(require("./defaultHTMLElementModels"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var HTMLModelRegistry = /*#__PURE__*/function () {
  function HTMLModelRegistry(customize) {
    _classCallCheck(this, HTMLModelRegistry);
    _defineProperty(this, "modelRecords", _defaultHTMLElementModels.default);
    if (typeof customize === 'function') {
      this.modelRecords = customize(_defaultHTMLElementModels.default);
    }
  }
  _createClass(HTMLModelRegistry, [{
    key: "getElementModelFromTagName",
    value: function getElementModelFromTagName(tagName) {
      if (tagName in this.modelRecords) {
        return this.modelRecords[tagName];
      }
      return null;
    }
  }]);
  return HTMLModelRegistry;
}();
exports.default = HTMLModelRegistry;